<template>
  <d-modal
    v-if="showModal"
    style="background-color: rgba(0,0,0,0.8)!important;">
    <d-modal-header>
      <d-modal-title class="mt-3 mb-3">
        {{label}}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <div class="form-group">
        <label for="reportMonth">
          Wybierz miesiąc: <span style="color: #c4183c">*</span>
        </label>
        <date-picker
          v-model="reportMonth"
          type="month"
          valueType="format"
          class="mr-2"
          style="width: 100%"
        />
      </div>
      <div class="form-group" v-if="role !== 'R_USER'">
        <validation-provider
          name="parent_id"
          v-slot="{ errors }">
          <label for="reportInstitutionId">Wybierz placówkę:</label>
          <div :class="{ 'form-control': true, 'is-select': true }">
            <v-select
              :options="institutions"
              v-model="reportInstitutionId"
              :reduce="institution => institution.id"
              placeholder="Lista placówek"
              label="id">
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.name }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.name }}
                </div>
              </template>
            </v-select>
          </div>
          <div class="invalid-feedback">
            {{ errors[0] }}
          </div>
        </validation-provider>
      </div>
      <div class="form-group mt-5">
        <d-button
          :disabled="role !== 'R_USER' ? (reportMonth === '' || reportInstitutionId === '') : reportMonth === ''"
          theme="info"
          style="width: 48%"
          class="mr-3"
          @click.prevent="downloadReport">
          <template v-if="!downloadingReport">
            <i class="material-icons">cloud_download</i>
            <span class="ml-2">Pobierz raport</span>
          </template>
          <template v-else>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </template>
        </d-button>
        <d-button
          style="width: 48%"
          @click.prevent="closeModal"
          theme="secondary">
          Anuluj
        </d-button>
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import FormUtils from '../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'holidays-children-report',
  components: {
    DatePicker
  },
  data() {
    return {
      institutions: [],
      reportMonth: '',
      reportInstitutionId: '',
      downloadingReport: false,
      loaded: false,
      loadError: false,
      removeInProgress: false,
      showAccepted: false,
      showRejected: false,
      filters: {
        search: '',
        accountStatus: ''
      }
    };
  },
  props: {
    showModal: {
      type: [String, Boolean],
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    plans: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
      default: 'R_ADMIN'
    },
  },
  mounted () {
    this.getInstitutionsList();
  },
  methods: {
    getInstitutionsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        outputKey: 'institutions',
        params: {
          pagination: false
        },
      });
    },
    downloadReport () {
      this.downloadingReport = true;
      let params = {
        only_plans: this.plans
      };
      if (this.reportMonth !== null) {
        params.report_date = this.reportMonth;
      }
      if (this.reportInstitutionId !== null) {
        params.institution_id = this.reportInstitutionId;
      }
      this.$http.post('/reports/monthly', {
        params
      }, {
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'raport-';
        let institution = '-placowka-';
        link.setAttribute('download', filename + this.reportMonth + institution + this.reportInstitutionId + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloadingReport = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
        this.downloadingReport = false;
      });
    },
  }
}
</script>

<style lang="scss">
  .vs__dropdown-option {
    white-space: normal;
  }
</style>
